import { render, staticRenderFns } from "./FormContratedit.vue?vue&type=template&id=22fbea2c&"
import script from "./FormContratedit.vue?vue&type=script&lang=js&"
export * from "./FormContratedit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports